// extracted by mini-css-extract-plugin
export default {"icon":"styles__icon___T3QNd","iconWithTooltip":"styles__iconWithTooltip___Yu4eG styles__icon___T3QNd","line":"styles__line___m+wWv","subPerex":"styles__subPerex___5d1bE"};